/* ======================================= *\
 * One to One Polymorphic model to store
 * date for created and modified for any
 * model that has it. Potentially to be
 * used for localStorage cache busting.
\* ======================================= */

import { Model } from '@vuex-orm/core';

export default class Date extends Model {
  static entity = 'dates';

  static fields() {
    return {
      id: this.uid(),
      date: this.attr(null),
      date_gmt: this.attr(null),
      modified: this.attr(null),
      modified_gmt: this.attr(null),

      // Relationship IDs
      dateable_id: this.attr(null),
      dateable_type: this.attr(null),
    };
  }
}
